export const getApplicationsData = async () => {
  try {
    const response = await fetch('https://wp.bala.bokeylibrary.kz/wp-content/themes/main/data/get_data.php?file=applications');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error applications', error);
    return [];
  }
};
